import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import ToDownload from "../../../../components/atoms/toDownload";
import { Box } from "@mui/material";

export const Columns: GridColDef[] = [
  {
    field: "docName",
    headerName: "Docs name",
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: "file",
    headerName: "Files",
    flex: 1.5,
    sortable: false,
    resizable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params: any) => (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
        <ToDownload params={params.value} />
      </Box>
    ),
  },
  {
    field: "version",
    headerName: "Version (original / copy)",
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: "user",
    headerName: "User",
    flex: 1,
    sortable: false,
    resizable: false,
    filterable: false,
    disableColumnMenu: true,
  },
];
